import { Navigate, useLocation } from 'react-router-dom';

import {
  canAccessDashboardRoute,
  defaultDashboardRoute,
} from '../lib/permissions';
import { appendPermissionDeniedAudit } from '../lib/securityAudit';
import { useSession } from '../stores/session';
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const user = useSession((s) => s.user);
  const loc = useLocation();
  if (!user)
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;

  if (!canAccessDashboardRoute(user, loc.pathname)) {
    appendPermissionDeniedAudit(
      `ปฏิเสธเส้นทาง ${loc.pathname} สำหรับ role ${user.role}`,
    );
    return <Navigate to={defaultDashboardRoute(user)} replace />;
  }

  return <>{children}</>;
}
